import { Component, ViewChild } from "@angular/core";
import { CatalogService } from "../../services/catalog.service";
import { WindowService } from "../../services/window.service";
import { Catalog, CatalogRequest } from "../../data/catalog";
import {
  fadeInOutAnimation,
  slideToLeftTransition,
  alertDisplay,
} from "../../animations";
import { OnInit } from "@angular/core";
import { Angulartics2 } from "angulartics2";
import { FormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { SupermodalSuccessComponent } from "@app/components/common/supermodal-success.component";
import { UserService } from "@app/services/user.service";
import * as $ from "jquery";
import * as _ from "underscore";
import { Plan } from "@app/data/user";

declare const $zoho;

@Component({
  templateUrl: "./catalogs.create.component.html",
  animations: [fadeInOutAnimation, slideToLeftTransition, alertDisplay],
})
export class CatalogsCreateComponent implements OnInit {
  @ViewChild("supermodalSuccess")
  supermodalSuccessComponent: SupermodalSuccessComponent;
  @ViewChild("supermodalRequest")
  supermodalRequestComponent: SupermodalSuccessComponent;
  title: string = "";
  step: string = "catalogInformation";
  templates: Catalog[] = [];
  blankTemplates: Catalog[] = [];
  catalogTemplates: Catalog[] = [];
  lookbookTemplates: Catalog[] = [];
  linesheetTemplates: Catalog[] = [];
  inventoryTagsTemplates: Catalog[] = [];
  selectedTemplate: Catalog = null;
  query: string;
  isLoading: boolean = false;
  isLoadingPreview: boolean = false;
  requestSent: boolean = false;
  page: number = 0;
  catalogMethod: string = "myself";
  hasAccessToCustomTemplate: boolean;
  isTrial: boolean;
  requestEmail: string = "";

  steps: {
    [id: string]: { title: string; next?: any; previous?: any };
  } = {
    creationMethod: {
      title: "Choose a method",
      next: () => {
        return this.catalogMethod == "myself"
          ? "catalogInformation"
          : "contactInformation";
      },
    },
    contactInformation: {
      title: "Send Custom Request",
      previous: "creationMethod",
    },
    catalogInformation: {
      title: "Choose a title (Step 1 of 2)",
      next: "chooseTemplate",
      // previous: "creationMethod"
    },
    chooseTemplate: {
      title: "Select a template (Step 2 of 2)",
      previous: "catalogInformation",
    },
  };
  catalogRequest: CatalogRequest = {
    name: "",
    email: "",
    deadline: "",
  };
  plan: Plan;

  constructor(
    private angulartics2: Angulartics2,
    private userService: UserService,
    private catalogService: CatalogService,
    private formBuilder: UntypedFormBuilder,
    private windowService: WindowService
  ) {}
  ngOnInit(): void {
    this.getTemplates();
    this.userService.me().then((user) => {
      this.plan = user.subscription.plan;
    });
    this.userService
      .hasAccess("custom-template")
      .then((hasAccess) => (this.hasAccessToCustomTemplate = hasAccess));
    this.isTrial = this.userService.isTrial;
  }

  selectTemplate(template) {
    this.selectedTemplate = template;
    this.page = 0;
    this.isLoadingPreview = true;
    this.createCatalog();
  }

  pdfLoadCompleted() {
    this.isLoadingPreview = false;
  }

  filter(): void {
    this.angulartics2.eventTrack.next({
      action: "Search for catalog",
      properties: { query: this.query },
    });
    this.templates = [];
    this.blankTemplates = [];
    this.catalogTemplates = [];
    this.linesheetTemplates = [];
    this.lookbookTemplates = [];
    this.inventoryTagsTemplates = [];
    this.getTemplates(this.query);
  }

  getTemplates(query?: string): void {
    this.requestSent = false;
    this.isLoading = true;
    this.catalogService.getTemplates(this.page, query).then((templates) => {
      this.templates.push(...templates);
      this.templates.forEach((template) => {
        if (template.tags.indexOf("blank") > -1) {
          this.blankTemplates.push(template);
        }
        if (template.tags.indexOf("retail") > -1) {
          this.catalogTemplates.push(template);
        }
        if (template.tags.indexOf("wholesale") > -1) {
          this.linesheetTemplates.push(template);
        }
        if (template.tags.indexOf("lookbook") > -1) {
          this.lookbookTemplates.push(template);
        }
        if (template.tags.indexOf("tags") > -1) {
          this.inventoryTagsTemplates.push(template);
        }
      });
      this.catalogTemplates = _.sortBy(this.catalogTemplates, "title");
      this.linesheetTemplates = _.sortBy(this.linesheetTemplates, "title");
      this.lookbookTemplates = _.sortBy(this.lookbookTemplates, "title");
      this.inventoryTagsTemplates = _.sortBy(
        this.inventoryTagsTemplates,
        "title"
      );
      this.isLoading = false;
    });
  }

  createCatalog(): void {
    this.catalogService
      .getCatalog(this.selectedTemplate._id)
      .then((selectedTemplate) => {
        let newCatalog = Object.assign(selectedTemplate, { title: this.title });
        delete newCatalog._id;
        delete newCatalog.created_at;
        delete newCatalog.updated_at;
        delete newCatalog.__v;
        delete newCatalog.download_number;
        this.angulartics2.eventTrack.next({
          action: "New Catalog Created",
          properties: { category: newCatalog.category },
        });
        this.catalogService.create(newCatalog).then((catalog) => {
          this.windowService.getNativeWindow().document.location.href =
            "/designs/" + catalog._id + "/edit";
        });
      });
  }

  createTemplateForMe() {
    this.angulartics2.eventTrack.next({
      action: "Template request",
      properties: { query: this.query },
    });
    this.requestSent = true;
  }

  previousPage() {
    this.page--;
  }

  nextPage() {
    this.page++;
  }

  nextStep() {
    this.step =
      typeof this.steps[this.step].next === "function"
        ? this.steps[this.step].next()
        : this.steps[this.step].next;
    console.log(this.step);
    this.angulartics2.eventTrack.next({
      action: "Create new catalog",
      properties: { step: this.step },
    });
  }

  previousStep() {
    this.step =
      typeof this.steps[this.step].previous === "function"
        ? this.steps[this.step].previous()
        : this.steps[this.step].previous;
  }

  onScroll() {
    this.page += 1;
    this.getTemplates(this.query);
  }

  sendRequest() {
    this.angulartics2.eventTrack.next({
      action: "Send a request for catalog",
      properties: { email: this.requestEmail },
    });
    this.catalogRequest.email = this.requestEmail;
    if ($zoho) {
      $zoho.salesiq.visitor.customaction("Send a request for catalog");
    }
    this.catalogService.sendRequest(this.catalogRequest).then(() => {
      this.supermodalSuccessComponent.open();
    });
  }

  moveToCatalogList() {
    window.location.href = "/catalogs/list";
  }
}
